import styled from "@emotion/styled"
import speakerbg from "../../images/speaker_bg.png"

export const MainContainer = styled.div`
  background-image: url(${speakerbg});
  background: #000;
  /* height:600px; */
  padding-top: 90px;
  @media (max-width: 800px) {
    padding: 90px 0px;
  }
`

export const Speaker = styled.img`
  width: 255px;
  height: 255px;
  border-radius: 100%;
`

export const SpeakerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 100px;
`
export const InnerContainer = styled.div`
  width: 80%;
  margin: auto;
  margin-top: 90px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
`

export const Name = styled.div`
  font-size: 24px;
  font-family: "Raleway";
  font-weight: 700;
  color: #1c1c24;
`

export const Occupation = styled.div`
  color: #5a5a5a;
  font-family: Poppins;
  font-size: 16px;
  margin-top: 10px;
`
